import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./Eventos.css";
import axios from "axios";
import { LocalData } from "../../Componentes/Util/LocalData";
import { Key } from "react-bootstrap-icons";
import Detalhes from "./Detalhes.js";

export default function Eventos() {
  const [produtos, setProdutos] = useState([]);
  const [Prod, setProd] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0)
  const [localdataPROD, setLocaldataPROD] = useState("");
  const [cabecalho, setCabecalho] = useState();

  useEffect(() => {
    const fetchEventos = async () => {
      $("#objCarregaTela").addClass("display-block");  
      try{
      //LocalData.set("prodID",[]);
      if(LocalData.get("prodID") !== "")
        setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
      }catch(e){}

        const response = await axios.get("https://api.construmarcas.com.br/api/produtos/!!EV!!");
        setProdutos(response.data);
    
      //caso tenha um cabecalho cadastrado, conforme identificado pelo nome do produto (#-#), criar variavel abaixo
    //   let cabec = null;
    //   try{
    //     cabec = JSON.parse(response.data.find((produto) => {
    //       let cabecalho =  JSON.parse(produto.dados).nome.indexOf("#-#") > -1;
    //       return cabecalho;
    //     }).dados);
    //   }catch(error){}
    //   setCabecalho(cabec);
      $("#objCarregaTela").removeClass("display-block");
    };

    fetchEventos();
  }, [LocalData.get("prodID")]);

    const evCliqueProduto = (e) =>
    {
      $(".area-produto").addClass("produto-selecionado");
      $(".area-impressao-produto").removeClass("selecionado");

      let p = produtos.find((produto) => {
        try {
          return JSON.parse(parseInt(JSON.parse(produto.dados).id) === parseInt($(e.currentTarget).attr("id")));
        } catch (error) {
          return null;
        }
      });
      //console.log(p.dados);
      let __prod = {...p, ...{indexBanner: 0}};
      //console.log("__prod", __prod);
      setProd([__prod]);
      setActiveIndex(0);
      
      $("body").addClass("overflow-hidden");
    }

    return (
        <div className="conteudo conteudo-eventos">
          <h3>Eventos</h3>
          <br />
            {
                produtos.map((evento, index) => {
                    let dados = JSON.parse(evento.dados);
                    console.log("dados", dados);
                    return (
                        <div key={index} className="capa" id={dados.id} onClick={evCliqueProduto}>
                            {
                                (dados.anexos.length > 0 && dados.anexos[0] !== null && dados.anexos[0] !== "null" && dados.anexos[0] !== "undefined")
                                ? <img src={dados.anexos[0].url} />
                                : null
                            }
                            <p>
                              <h2>{dados.nome.split("!!EV!!")[1]}</h2>
                              {
                                dados.seo.description
                              }
                            </p>
                        </div>
                    );
                    // JSON.parse(evento.dados).nome.indexOf("#-#") > -1 ?
                    //     <div key={index} className="evento">
                    //         <div className="imagem-evento">
                    //             <img src={JSON.parse(evento.dados).anexos[0].url} alt={JSON.parse(evento.dados).nome} />
                    //         </div>
                    //         <div className="descricao-evento">
                    //             <h3>{JSON.parse(evento.dados).nome}</h3>
                    //             <span>{JSON.parse(evento.dados).descricaoComplementar}</span>
                    //         </div>
                    //     </div> : null
                    })
            }
              <Detalhes Lista={Prod}></Detalhes>
        </div>
    )
}